var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_12406_45874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.666 5.33594C11.7706 5.33594 12.666 4.44051 12.666 3.33594C12.666 2.23137 11.7706 1.33594 10.666 1.33594C9.56145 1.33594 8.66602 2.23137 8.66602 3.33594C8.66602 4.44051 9.56145 5.33594 10.666 5.33594Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 10C3.77156 10 4.66699 9.10457 4.66699 8C4.66699 6.89543 3.77156 6 2.66699 6C1.56242 6 0.666992 6.89543 0.666992 8C0.666992 9.10457 1.56242 10 2.66699 10Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 14.6641C11.7706 14.6641 12.666 13.7686 12.666 12.6641C12.666 11.5595 11.7706 10.6641 10.666 10.6641C9.56145 10.6641 8.66602 11.5595 8.66602 12.6641C8.66602 13.7686 9.56145 14.6641 10.666 14.6641Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39355 9.00781L8.94689 11.6611",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94022 4.33594L4.39355 6.98927",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12406_45874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.f48f2a91d6ad1e7d0589a229b52b1e56.svg";
export { ForwardRef as ReactComponent };